import { render, staticRenderFns } from "./AddFilesToProjectModal.vue?vue&type=template&id=87d2ce98"
import script from "./AddFilesToProjectModal.vue?vue&type=script&lang=ts"
export * from "./AddFilesToProjectModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports